import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { catchError, forkJoin, map } from 'rxjs';
import { MCMISUpload } from '../interfaces/MCMISUpload';
import axios from 'axios';

@Injectable({
  providedIn: 'root'
})
export class ConfigDataService {

     version:string = "";
     updateDate:MCMISUpload = {nextMCMISUploadDate: '', mcmisUploadDate: '' };
     constructor(private http: HttpClient) { 
          const url = `${environment.APP_API_URL}/api/v1/ConfigData/getConfig?configKey=Business-Version`;
          this.http.get(url,{responseType: 'text'}).subscribe(
               (data: string) => {
                 this.version = data as string;
               },
               (error) => {
                 console.error('Error:', error);
               }
          );

          const url_MCMISUploadDate = `${environment.APP_API_URL}/api/v1/ConfigData/getConfig?configKey=MCMISUploadDate`;
          const _MCMISUploadDate = this.http.get(url_MCMISUploadDate,{responseType: 'text'});
          const url_NextMCMISUploadDate = `${environment.APP_API_URL}/api/v1/ConfigData/getConfig?configKey=NextMCMISUploadDate`;
          const _NextMCMISUploadDate = this.http.get(url_NextMCMISUploadDate,{responseType: 'text'});
          forkJoin([_MCMISUploadDate,_NextMCMISUploadDate]).subscribe(
               (results: any[]) => {
                    this.updateDate.mcmisUploadDate = results[0];
                    this.updateDate.nextMCMISUploadDate = results[1];
               }
          )
     }

     getLoadedData(): Promise<MCMISUpload> {
          return new Promise<MCMISUpload>(async (resolve) => {
              const mcmisUploadDate = await this.getConfig('MCMISUploadDate');
              const nextMCMISUploadDate = await this.getConfig('NextMCMISUploadDate');
              resolve({ nextMCMISUploadDate: nextMCMISUploadDate, mcmisUploadDate: mcmisUploadDate } as MCMISUpload);
          });
      }
  
      getGovShutdownInfo(): Promise<string[]> {
          return new Promise<string[]>(async (resolve) => {
              const show = await this.getConfig('GovShutdownOn');
              const header = await this.getConfig('GovShutdownHeader');
              const text = await this.getConfig('GovShutdownText');
              resolve([show,header,text] as string[]);
          });
      }
  
      getConfig(configKey: string): any {
          const url: string = `${environment.APP_API_URL}/api/v1/ConfigData/getConfig?configKey=${configKey}`;
          return axios.get(url)
              .then((response) => (response.data))
              .catch((error) => {
                  console.error(error);
                  return ({});
              });
      }
}
